module.exports = __webpack_public_path__ + "static/canid-vaccine-1df940fd32a37dc27e1c2967a3620e25.svg";